import { PositionCode } from '@rendora/common/entities/analysis_backend';
import { getGlobalConfig } from '@rendora/common/utils/config';
import { jumpTo } from '@rendora/common/utils/jumpTo';
import { getPlatformJumpLink } from '@rendora/common/utils/url';
import { useContactUs, useContactUsByLink } from './libs/useContactUs';

export { PositionCode, useContactUs, useContactUsByLink };

export const showDynamicContact = async (code: PositionCode) => {
  if (getGlobalConfig().isCN) {
    useContactUs(code);
  } else {
    jumpTo(getPlatformJumpLink(`/contact-us`));
  }
};

export const openContact = async (url: string) => {
  if (getGlobalConfig().isCN) {
    useContactUsByLink(url);
  } else {
    jumpTo(getPlatformJumpLink(`/contact-us`));
  }
};
